import { z } from 'zod';

import {
  companyInviteStatusValues,
  type CompanyInviteDto,
  type CompanyInviteStatus,
  type CreateCompanyInviteRequest,
  type CreateCompanyInviteResponse,
  type ListCompanyInvitesRequest,
  type ListCompanyInvitesResponse,
  type RevokeCompanyInviteRequest,
  type RevokeCompanyInviteResponse,
} from './company-invite.dto.js';

const timestampSchema = z.iso.datetime();

export const CompanyInviteSchema: z.ZodType<CompanyInviteDto> = z.object({
  id: z.uuid(),
  companyId: z.uuid(),
  email: z.string().trim().pipe(z.email()),
  status: z.enum(companyInviteStatusValues),
  pendingRoleIds: z.array(z.uuid()).optional(),
  expiresAt: timestampSchema,
  createdAt: timestampSchema,
  createdByUserId: z.uuid(),
});

export const CreateCompanyInviteRequestSchema: z.ZodType<CreateCompanyInviteRequest> = z.object({
  companyId: z.uuid(),
  email: z.string().trim().pipe(z.email()),
  pendingRoleIds: z.array(z.uuid()).default([]),
  expiresInDays: z.number().int().min(1).max(365).optional(),
});

export const CreateCompanyInviteResponseSchema: z.ZodType<CreateCompanyInviteResponse> = z.object({
  invite: CompanyInviteSchema,
  inviteToken: z.string().min(1),
});

export const ListCompanyInvitesRequestSchema: z.ZodType<ListCompanyInvitesRequest> = z.object({
  companyId: z.uuid(),
});

export const ListCompanyInvitesResponseSchema: z.ZodType<ListCompanyInvitesResponse> = z.object({
  items: z.array(CompanyInviteSchema),
});

export const RevokeCompanyInviteRequestSchema: z.ZodType<RevokeCompanyInviteRequest> = z.object({
  companyId: z.uuid(),
  inviteId: z.uuid(),
});

export const RevokeCompanyInviteResponseSchema: z.ZodType<RevokeCompanyInviteResponse> = z.object({
  invite: CompanyInviteSchema,
});

export const CompanyInviteStatusSchema: z.ZodType<CompanyInviteStatus> = z.enum(
  companyInviteStatusValues,
);

